import LivewireVue from './livewire-vue';
import Overlay from './livewire-overlay';
import Confirm from './livewire-confirm';
import SubmitAll from './livewire-submitall';

LivewireVue();
Overlay();
Confirm();
SubmitAll();
